import PropTypes from 'prop-types';
import { useCallback } from 'react';
import useTranslation from '../hooks/useTranslation';

const NOMENCLATURE_ADA_CHILD = {
  55: 'A',
  54: 'B',
  53: 'C',
  52: 'D',
  51: 'E',
  61: 'F',
  62: 'G',
  63: 'H',
  64: 'I',
  65: 'J',
  85: 'T',
  84: 'S',
  83: 'R',
  82: 'Q',
  81: 'P',
  71: 'O',
  72: 'N',
  73: 'M',
  74: 'L',
  75: 'K'
};

const NOMENCLATURE_ADA_ADULT = {
  18: '1',
  17: '2',
  16: '3',
  15: '4',
  14: '5',
  13: '6',
  12: '7',
  11: '8',
  21: '9',
  22: '10',
  23: '11',
  24: '12',
  25: '13',
  26: '14',
  27: '15',
  28: '16',
  38: '17',
  37: '18',
  36: '19',
  35: '20',
  34: '21',
  33: '22',
  32: '23',
  31: '24',
  41: '25',
  42: '26',
  43: '27',
  44: '28',
  45: '29',
  46: '30',
  47: '31',
  48: '32'
};

export function OdontogramReport({
  teeth,
  isChild,
  isADA
}) {
  const { t } = useTranslation();
  const formatTeeth = useCallback((odontogram, ADA, child) => {
    if (!ADA) {
      const formatFDI = odontogram.map((tooth) => {
        return `${tooth.toString()[0]}.${tooth.toString()[1]}`;
      });
      return formatFDI.join(', ');
    }
    if (ADA && child) {
      return teeth.map((tooth) => NOMENCLATURE_ADA_CHILD[tooth]).join(', ');
    }
    if (ADA && !child) {
      return teeth.map((tooth) => NOMENCLATURE_ADA_ADULT[tooth]).join(', ');
    }
    return teeth.join(', ');
  }, [teeth]);

  const formatIsChild = useCallback((child) => {
    if (child) {
      return t('Child');
    }
    return t('Adult');
  }, [t]);
  const formatIsADA = useCallback((ADA) => {
    if (ADA) {
      return 'ADA';
    }
    return 'FDI';
  }, []);
  return (
    <div>
      {teeth && (
        <span className="me-1">
          {formatTeeth(teeth, isADA, isChild)}
        </span>
      )}
      <span className="badge badge-pill bg-primary me-1">
        {formatIsADA(isADA)}
      </span>
      <span className="badge badge-pill bg-secondary">
        {formatIsChild(isChild)}
      </span>
    </div>
  );
}

OdontogramReport.propTypes = {
  teeth: PropTypes.array,
  isChild: PropTypes.bool,
  isADA: PropTypes.bool
};

export default OdontogramReport;
